module.exports = {
  availableThemes: ['alterra', 'default'],
};
